(() => {
  let pending = false;
  const cartPath = (window.Shopify?.routes?.root || '/') + 'cart';
  const open = async trigger => {
    if (pending) return;
    pending = true;
    try {
      await customElements.whenDefined('cart-drawer');
      const drawer = document.getElementById('CartDrawer');
      if (!drawer || (!drawer.hidden && drawer.hasAttribute('active'))) return;
      const menuClose = document.querySelector('.picco-ref-drawer:not([hidden]) [data-close-mobile-menu]');
      menuClose?.click();
      drawer.show(trigger);
    } finally { pending = false; }
  };
  document.addEventListener('click', event => {
    const control = event.target.closest?.('.cart-drawer-button, a[href]');
    if (!control) return;
    let cartLink = control.matches('.cart-drawer-button');
    if (!cartLink && control.tagName === 'A') {
      const url = new URL(control.href, location.origin);
      cartLink = url.origin === location.origin && url.pathname.split('/').filter(Boolean).join('/') === cartPath.split('/').filter(Boolean).join('/');
    }
    if (!cartLink) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(control);
  }, true);
  const start = () => {
    const url = new URL(location.href);
    if (url.searchParams.get('open_cart') !== '1') return;
    url.searchParams.delete('open_cart');
    history.replaceState(history.state, '', url.href);
    open(document.querySelector('.cart-drawer-button'));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();